import Icon from "@/components/Ui/Icon";
import { twMerge } from "tailwind-merge";

type Props = {
  disabled?: boolean;
  className?: string;
};

const Spinner = ({ disabled, className = "" }: Props) => (
  <div className="relative inline-block leading-0">
    <Icon className={twMerge("text-input", className)} name="spinner-circle" />
    {!disabled && (
      <Icon
        className={twMerge(
          "text-primary absolute inset-0 animate-spin",
          className,
        )}
        name="spinner-inner"
      />
    )}
  </div>
);

export default Spinner;
